import { LANGUAGE } from "@/common/utils/constants.js";

export const SIDE_MENU = {
	[LANGUAGE.en.short]: {
		stories: "Stories",
		create: "Create",
		createOffer: "Create Offer",
		allStories: "All Stories",
		manage: "Manage Content",
		daysOff: "Days Off",
		manageLabels: "Manage Labels",
		personal: "Personal",
		myStories: "My Stories",
		mySubscriptions: "My Subscriptions",
		saved: "Saved",
		savedContent: "Saved Content",
		pages: "Pages",
		industries: "Industries",
		serviceLines: "Type of Business",
		techPractices: "Tech Practices",
		FAQs: "Resources",
		viewAll: "View all",
		back: "Back",
		logout: 'Logout',
		controlPanel: "Control Panel",
		platform: "PLATFORM",
		home: "Home",
		search: "Search",
		createSector: "Create Presentation",
		reporting: "Reporting",
		createRecognition: "Create Recognition",
		recognitions: "Recognitions",
	},
	[LANGUAGE.it.short]: {
		stories: "Storie",
		create: "Creare",
		createOffer: "Crea offerta",
		allStories: "Tutte le storie",
		manage: "Gestisci i contenuti",
		daysOff: "Giorni liberi",
		manageLabels: "Gestisci etichette",
		personal: "Personale",
		myStories: "Le mie storie",
		mySubscriptions: "I miei abbonamenti",
		saved: "Salvato",
		savedContent: "Contenuti salvati",
		pages: "Pagine",
		industries: "Industrie",
		serviceLines: "Tipo de asunto",
		techPractices: "Pratiche tecnologiche",
		FAQs: "Risorse",
		viewAll: "Mostra tutto",
		back: "Indietro",
		logout: 'Disconnettersi',
		controlPanel: "Pannello di controllo",
		platform: "PIATTAFORMA",
		home: "Casa",
		search: "Ricerca",
		createSector: "Creare una presentazione",
		reporting: "Segnalazione",
		createRecognition: "Crea riconoscimento",
		recognitions: "Riconoscimenti",
	},
	[LANGUAGE.de.short]: {
		stories: "Geschichten",
		create: "Erstellen",
		createOffer: "Angebot erstellen",
		allStories: "Alle Geschichten",
		manage: "Inhalte verwalten",
		daysOff: "Freie Tage",
		manageLabels: "Etiketten verwalten",
		personal: "Persönlich",
		myStories: "Meine Geschichten",
		mySubscriptions: "Meine Abonnements",
		saved: "Gespeichert",
		savedContent: "Gespeicherte Inhalte",
		pages: "Seiten",
		industries: "Branchen",
		serviceLines: "Art des Geschäfts",
		techPractices: "Technische Praktiken",
		FAQs: "Ressourcen",
		viewAll: "Alle ansehen",
		back: "Zurück",
		logout: 'Ausloggen',
		controlPanel: "Bedienfeld",
		platform: "PLATTFORM",
		home: "Heim",
		search: "Suche",
		createSector: "Präsentation erstellen",
		reporting: "Berichterstattung",
		createRecognition: "Anerkennung erstellen",
		recognitions: "Anerkennungen",
	},
	[LANGUAGE.fr.short]: {
		stories: "Histoires",
		create: "Créer",
		createOffer: "Créer une offre",
		allStories: "Toutes les histoires",
		manage: "Gérer le contenu",
		daysOff: "Jours de congés",
		manageLabels: "Gérer les étiquettes",
		personal: "Personnel",
		myStories: "Mes histoires",
		mySubscriptions: "Mes abonnements",
		saved: "Enregistré",
		savedContent: "Contenu enregistré",
		pages: "Pages",
		industries: "les industries",
		serviceLines: "Type d'entreprise",
		techPractices: "Pratiques technologiques",
		FAQs: "Ressources",
		viewAll: "Voir tout",
		back: "Dos",
		logout: 'Se déconnecter',
		controlPanel: "Panneau de contrôle",
		platform: "PLATE-FORME",
		home: "Maison",
		search: "Chercher",
		createSector: "Créer une présentation",
		reporting: "Rapport",
		createRecognition: "Créer une reconnaissance",
		recognitions: "Reconnaissances",
	},
	[LANGUAGE.ja.short]: {
		stories: "物語",
		create: "作成",
		createOffer: "オファーを作成",
		allStories: "すべての物語",
		manage: "コンテンツの管理",
		daysOff: "休日",
		manageLabels: "ラベルを管理する",
		personal: "個人的",
		myStories: "私の話",
		mySubscriptions: "私の購読",
		saved: "保存",
		savedContent: "保存されたコンテンツ",
		pages: "ページ",
		industries: "産業",
		serviceLines: "事業の種類",
		techPractices: "技術慣行",
		FAQs: "リソース",
		viewAll: "すべて見る",
		back: "戻る",
		logout: 'ログアウト',
		controlPanel: "コントロールパネル",
		platform: "プラットホーム",
		home: "家",
		search: "サーチ",
		createSector: "プレゼンテーションを作成",
		reporting: "報告",
		createRecognition: "認識を作成",
		recognitions: "認識",
	},
	[LANGUAGE.es.short]: {
		stories: "Historias",
		create: "Crear",
		createOffer: "Crear oferta",
		allStories: "Todas las historias",
		manage: "Gestionar contenido",
		daysOff: "Días libres",
		manageLabels: "Gestionar etiquetas",
		personal: "Personal",
		myStories: "Mis historias",
		mySubscriptions: "Mis suscripciones",
		saved: "Guardado",
		savedContent: "Contenido guardado",
		pages: "Páginas",
		industries: "Industrias",
		serviceLines: "Tipo de asunto",
		techPractices: "Prácticas tecnológicas",
		FAQs: "Recursos",
		viewAll: "Ver todo",
		back: "Atrás",
		logout: 'Cerrar sesión',
		controlPanel: "Panel de control",
		platform: "PLATAFORMA",
		home: "Inicio",
		search: "Buscar",
		createSector: "Crear presentación",
		reporting: "Informes",
		createRecognition: "Crear reconocimiento",
		recognitions: "Reconocimientos",
	}
}
